import moment from 'moment/moment';
import { usePage } from '@inertiajs/vue3';

export default {
	currentLocale(locale) {
		return usePage().props.locale || locale || navigator.language;
	},
	formatCurrency(
		value,
		currency = 'EUR',
		locale = 'en-US',
		minDigits,
		maxDigits,
	) {
		if (value === null) {
			return value;
		}
		const formatter = new Intl.NumberFormat(this.currentLocale(locale), {
			style: 'currency',
			currency: currency,
			minimumFractionDigits: minDigits || 2,
			maximumFractionDigits: maxDigits || 2,
		});
		return formatter.format(value);
	},
	formatNumber(value, minDigits, maxDigits) {
		const formatter = new Intl.NumberFormat(this.currentLocale(), {
			style: 'decimal',
			minimumFractionDigits: minDigits || 0,
			maximumFractionDigits: maxDigits || 2,
		});
		return formatter.format(value);
	},
	formatDate(value, format) {
		if (value) {
			return moment(String(value)).format(format || 'YYYY-MM-DD HH:mm');
		}
		return value;
	},
	localizedDate(value, locale) {
		if (value) {
			const formatter = new Intl.DateTimeFormat(this.currentLocale(locale), {
				// dateStyle: 'short',
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				// hour: '2-digit',
				// minute: '2-digit',
				// hour12: false,
				// second: '2-digit',
				// timeStyle: 'short',
				// timeZone: 'UTC',
			});
			return formatter.format(new Date(value));
		}
		return value;
	},
	localizedDateTime(value, locale) {
		if (value) {
			const formatter = new Intl.DateTimeFormat(this.currentLocale(locale), {
				// dateStyle: 'short',
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				// hour12: false,
				// second: '2-digit',
				// timeStyle: 'short',
				// timeZone: 'UTC',
			});
			return formatter.format(new Date(value));
		}
		return value;
	},
	compareDates(date1, date2) {
		const firstDate = moment(date1).format('YYYY-MM-DD');
		const secondDate = moment(date2).format('YYYY-MM-DD');
		if (firstDate === secondDate) return 0;
		return firstDate < secondDate ? -1 : 1;
	},
};
